
(function () {
  if (window.__booksyCopyInit) return;
  window.__booksyCopyInit = true;

  function flash(btn) {
    var icon = btn.querySelector('.booksy-copy__icon');
    var prev = icon ? icon.textContent : null;
    if (icon) icon.textContent = '✓';
    btn.setAttribute('data-copied', '1');
    setTimeout(function () {
      if (icon && prev !== null) icon.textContent = prev;
      btn.removeAttribute('data-copied');
    }, 1600);
  }

  function legacyCopy(text) {
    try {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    } catch (e) { /* csendben */ }
  }

  function copy(text, btn) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function () {
        flash(btn);
      }).catch(function () {
        legacyCopy(text);
        flash(btn);
      });
    } else {
      legacyCopy(text);
      flash(btn);
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.booksy-copy') : null;
    if (!btn) return;
    var code = btn.getAttribute('data-code');
    if (!code) return;
    e.preventDefault();
    copy(code, btn);
  });
})();
